export default __webpack_public_path__ + "static/media/whatsapp-notice-m-2.f7dc6b9f.webp";